import React, { memo } from 'react';

import { AppointmentsProvider } from './context';
import Frame from './Frame';

const Appointments = ({ children }) => (
  <AppointmentsProvider>
    <Frame>{children}</Frame>
  </AppointmentsProvider>
);
export default memo(Appointments);
